import StudentProgressTestResult from './model';

export default StudentProgressTestResult;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/index.js